import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';

import { ValidatedTokenService } from '@app/shared/services/validated-token/validated-token.service';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-occurence-description',
  templateUrl: './occurence-description.component.html',
  styleUrls: ['./occurence-description.component.css']
})
export class OccurenceDescriptionComponent implements OnInit {

  @Input() occurrenceForm: FormGroup;
  @ViewChild('autosize', { read: false }) autosize: CdkTextareaAutosize;

  constructor(private validatedTokenService: ValidatedTokenService) { }

  ngOnInit() {
    this.autosize.minRows = 5;
    this.validatedComments();
  }

  validatedComments() {
    const comments = this.occurrenceForm.get('description');

    comments.valueChanges
      .pipe(debounceTime(100))
      .subscribe(description => comments.setValue(this.validatedTokenService.DOMParser(description)));
  }
}
